import NotificationCard from "./NotificationCard";

export default function TimelineNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="timeline"
            destination={
                "/analysis?video=" +
                props.notification.file +
                "&key=" +
                props.notification.key
            }
            mediaUrl={
                "https://vz-db0e7359-d70.b-cdn.net/" +
                props.notification.file +
                "/thumbnail.jpg"
            }
            mediaAlt="Timeline video thumbnail"
        />
    );
}
